import React, { useCallback, useEffect, useState } from "react";
// import HeaderImage from "../../../assets/Image/Slider11.jpg";
import MainFooter from "../../../components/mainfooter/MainFooter";
import StickySidebar from "../../../components/stickysidebar/StickySidebar";
import MainHeader from "../../../components/mainheader/MainHeaderNew";
import { fetchOrderDetailsByUserId } from "../../../redux/slices/orderSlice";
import { useDispatch, useSelector } from "react-redux";
import { REACT_APP_URL, axiosInstance } from "../../../config";
import { toastError } from "../../../utils/reactToastify";
// import { Link } from "react-router-dom";
import OrderList from "../../../components/order/OrderList";
import Preloader from "../../../components/preloader/Preloader";
import { Link } from "react-router-dom";

function UserOrders() {
  const { loading, useOrders } = useSelector((state) => state.orders);
  const dispatch = useDispatch();
  const [allOrders, setAllOrders] = useState([]);
  const [headerImage, setHeaderImage] = useState({});

  const fetchRootCollection = useCallback(async () => {
    try {
      const { data } = await axiosInstance.get(
        `/api/header-image/title/UserOrders`
      );
      if (data?.success) {
        setHeaderImage(data?.data);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toastError(error?.response?.data?.message);
      } else {
        toastError(error?.message);
      }
    }
  }, []);
  useEffect(() => {
    fetchRootCollection();
  }, [fetchRootCollection]);

  useEffect(() => {
    if (loading === "fulfilled" && useOrders && useOrders?.length) {
      setAllOrders(useOrders);
    }
  }, [loading, useOrders]);

  useEffect(() => {
    dispatch(fetchOrderDetailsByUserId());
  }, [dispatch]);

  return (
    <>
      <StickySidebar />
      <MainHeader isImageAvailable={headerImage?.pngImage ? true : false} />
      <div
        style={{
          height: headerImage?.pngImage ? "60vh" : "11vh",
          overflow: "hidden",
          position: "relative",
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.5)), url(${REACT_APP_URL}/images/header/${headerImage?.pngImage})`,
          backgroundSize: "cover",
        }}
      ></div>
      <div className="gradient-overlay" />
      <div className="col-lg-2" style={{ float: "left" }}>
        &nbsp;
      </div>
      <div className="col-lg-2" style={{ float: "left" }}>
        &nbsp;
      </div>

      {/* <br /> */}

      {loading === "pending" ? (
        <Preloader />
      ) : allOrders && allOrders?.length > 0 ? (
        <OrderList allOrders={allOrders} />
      ) : (
        <>
          <br />
          <br />
          <br />
          <center>
            <h2>Your Order History is Empty!</h2>
            <p>
              It looks like you haven't placed any orders with us yet. Once you
              start shopping, all your orders will appear here.
            </p>
            <br></br>
            <Link
              to="/"
              style={{
                textAlign: "center",
                padding: "10px 20px",
                backgroundColor: "black",
                color: "white",
                textDecoration: "none",
                marginTop: "20px",
              }}
            >
              Browse Our Products Now
            </Link>
            <br />
            <br />
            <br />
            <br />
          </center>
        </>
      )}
      <MainFooter />
    </>
  );
}

export default UserOrders;
